import React, { useEffect, useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Button,
  TextField,
  Typography,
  Box,
  makeStyles,
} from "@material-ui/core";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getRewardTokenName } from "./reward";
import moment from "moment";
import { statService } from "services/rewardService";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  dateField: {
    margin: theme.spacing(1),
  },
  chartContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "white",
    padding: theme.spacing(2),
  },
  chartTitle: {
    marginBottom: theme.spacing(2),
  },
  filter: {
    display: "flex",
    flexDirection: "row",
    maxWidth: "100%",
    flexWrap: "wrap",
    marginBottom: theme.spacing(5),
  },
}));

export default function RewardStat() {
  const classes = useStyles();

  const [type, setType] = useState("daily");
  const [fromTime, setFromTime] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [toTime, setToTime] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [data, setData] = useState([]);
  const [rewardCoin, setRewardCoin] = useState();

  const dataKey = {
    weekly: "week",
    monthly: "month",
    daily: "date",
  };

  // fetch data from the API
  const fetchData = () => {
    const fromDate = new Date(fromTime).getTime();
    const toDate = new Date(toTime).getTime();
    const { data } = statService.rewared(fromDate, toDate, type);
    setData(data);
  };

  // handle type change
  const handleTypeChange = (event) => {
    setType(event.target.value);
  };

  // handle date range change
  const handleFromTimeChange = (event) => {
    setFromTime(event.target.value);
  };

  // handle toTime change
  const handleToTimeChange = (event) => {
    setToTime(event.target.value);
  };

  // handle fetch button click
  const handleFetchClick = () => {
    fetchData();
  };

  function formatXAxis(tickItem) {
    return moment(tickItem).format("MMM Do YY");
  }

  useEffect(() => {
    getRewardTokenName().then((tokenName) => {
      setRewardCoin(tokenName);
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, [type]);

  // render the component
  return (
    <div className={classes.chartContainer}>
      <Typography variant="h5" className={classes.chartTitle}>
        Reward Statistics
      </Typography>

      <Box display="flex" alignItems="center" className={classes.filter}>
        <FormControl className={classes.formControl}>
          <Select value={type} onChange={handleTypeChange}>
            <MenuItem value="daily">Daily</MenuItem>
            <MenuItem value="weekly">Weekly</MenuItem>
            <MenuItem value="monthly">Monthly</MenuItem>
          </Select>
        </FormControl>
        <TextField
          type="date"
          onChange={handleFromTimeChange}
          value={fromTime}
          className={classes.dateField}
        />
        <TextField
          type="date"
          onChange={handleToTimeChange}
          value={toTime}
          className={classes.dateField}
        />
        <Button onClick={handleFetchClick}>Fetch</Button>
      </Box>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart width={600} height={300} data={data}>
          <XAxis dataKey={dataKey[type]} tickFormatter={formatXAxis} />
          <YAxis unit={rewardCoin} width={70} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="totalReward" stroke="#8884d8" />
          <Line type="monotone" dataKey="sellerReward" stroke="#82ca9d" />
          <Line type="monotone" dataKey="buyerReward" stroke="#ffc658" />
          <Line
            type="monotone"
            dataKey="collectionOwnerReward"
            stroke="#ff7300"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
